import { render, staticRenderFns } from "./yidi.vue?vue&type=template&id=4f2c1d30&scoped=true&"
import script from "./yidi.vue?vue&type=script&lang=js&"
export * from "./yidi.vue?vue&type=script&lang=js&"
import style0 from "./yidi.vue?vue&type=style&index=0&id=4f2c1d30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2c1d30",
  null
  
)

export default component.exports